<div *ngIf="account" class="layout-column tr fade-element-in-only">

  <div class="flex layout-row layout-align-start-center"
       (mouseenter)="isHover = true"
       (mouseleave)="isHover = false">
    <!--Account-->
    <div class="td sticky flex-10 layout-row layout-align-start-center position-relative" [style.width.px]="totalsColSize"
         [style.minWidth.px]="totalsColSize" [style.maxWidth.px]="totalsColSize">

      <bringoz-icon (click)="onOpenAccountInfo.emit({account: account}); $event.stopPropagation();"
                    iconName="info-outline" classSize="md" class="gray-102 pointer"
                    ngbTooltip="{{'Show Account Info' | translate}}"></bringoz-icon>

      <div ngbDropdown container="body">
        <button class="action-menu"
                (click)="$event.stopPropagation();"
                ngbDropdownToggle>
          <bringoz-icon iconName="menu"></bringoz-icon>
        </button>
        <div ngbDropdownMenu aria-labelledby="action-menu">

          <button
            ngbDropdownItem
            (click)="onRemoveAccountDeliveries()">
            <div class="layout-row layout-align-start-center">
              <span class="br-body-2 primary-100" translate>Remove all deliveries for this account (week)</span>
            </div>
          </button>

        </div>
      </div>

      <span class="br-body-1 font-weight-600 gray-100 flex text-ellipsis layout-row layout-align-start-center"
            [ngbTooltip]="accountTooltipTmpl"
            openDelay="300"
            triggers="hover"
            container="body">

          <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
            <app-bringoz-state-link class="text-ellipsis"
                                    [permission]="'accounts.demand.get'"
                                    [state]="'accounts-detail-demand.info.preferences'"
                                    [params]="{id: account.accountReference.id}"
                                    [text]="account.accountReference.name"
                                    [openInNewTab]="true">
            </app-bringoz-state-link>
          </ng-container>
          <span *ngxPermissionsExcept="'schedulingProject.visitPlan.update'" class="text-ellipsis">{{ account.accountReference.name }}</span>

        <ng-template #accountTooltipTmpl>
          <div class="layout-column gap-5">
            <div class="layout-row layout-align-start-center">
              <span>{{ account.accountReference.name }}</span>
            </div>
            <div class="layout-row layout-align-start-center">
               <span>{{ account.address | bringozAddress }}</span>
            </div>
            <div *ngIf="account.strategicPriority?.segment != null" class="layout-row layout-align-start-center">
              <span>{{'Segment' | translate}}: {{account.strategicPriority.segment}}</span>
            </div>
          </div>
        </ng-template>
        <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
          <bringoz-button *ngIf="(account.locked || isHover)"
                          type="tertiary"
                          size="fit"
                          class="account-lock-btn margin-right-6"
                          container="body"
                          openDelay="300"
                          (onClick)="onLockAccountChange.emit({id: account.id, locked: !account.locked});$event.stopPropagation();">
              <bringoz-icon [iconName]="account.locked ? 'lock' : 'lock-open-outline'" classSize="md"
                            fill="#484848"></bringoz-icon>
          </bringoz-button>
        </ng-container>
      </span>
<!--      <span class="br-body-1 font-weight-400 gray-100 flex-10">-->
<!--        <app-bringoz-items-list-display flex-->
<!--                                        [items]="notesList"-->
<!--                                        prefix="roles"-->
<!--                                        [maxItems]="1">-->

<!--        </app-bringoz-items-list-display>-->
<!--      </span>-->
      <div *ngIf="tableFilterColumns.isDisplayCallTypes" class="layout-column br-body-1 font-weight-400 gray-100 total-value">
        <span>{{ totals.merchandiseCount | number }}</span>
        <span *ngIf="totals.merchandiseCount !== totals.merchandiseInitialCount" style="text-decoration: line-through;">{{totals.merchandiseInitialCount | number}}</span>
      </div>
      <div *ngIf="tableFilterColumns.isDisplayCallTypes" class="layout-column br-body-1 font-weight-400 gray-100 total-value">
        <span>{{ totals.ordersCount | number }}</span>
        <span *ngIf="totals.ordersCount !== totals.ordersInitialCount" style="text-decoration: line-through;">{{totals.ordersInitialCount | number}}</span>
      </div>
      <div *ngIf="tableFilterColumns.isDisplayCallTypes" class="layout-column br-body-1 font-weight-400 gray-100 total-value">
        <span>{{ totals.salesCount | number }}</span>
        <span *ngIf="totals.salesCount !== totals.salesInitialCount" style="text-decoration: line-through;">{{totals.salesInitialCount | number}}</span>
      </div>
      <div *ngIf="tableFilterColumns.isDisplayDeliveryUnits" class="layout-column br-body-1 font-weight-400 gray-100 total-value du">
        <span>{{ totals.deliveryUnitsCount | number }}</span>
        <span *ngIf="totals.deliveryUnitsCount !== totals.deliveryUnitsInitialCount" style="text-decoration: line-through;">{{totals.deliveryUnitsInitialCount | number}}</span>
      </div>
      <div *ngIf="tableFilterColumns.isDisplayDeliveryDays" class="layout-column br-body-1 font-weight-400 gray-100 total-value du">
        <span>{{ totals.deliveryDaysCount | number }}</span>
        <span *ngIf="totals.deliveryDaysCount !== totals.deliveryDaysInitialCount" style="text-decoration: line-through;">{{totals.deliveryDaysInitialCount | number}}</span>
      </div>
      <div *ngIf="tableFilterColumns.isDisplayServiceTime" class="layout-column br-body-1 font-weight-400 gray-100 total-value large"
           [ngbTooltip]="extendedServiceTimeTooltipTmpl"
           openDelay="300"
           container="body"
           triggers="hover">
        <span>{{ totals.serviceTimeTotal | bringozTimeHHMM }}</span>
        <span *ngIf="totals.serviceTimeTotal !== totals.serviceTimeInitialTotal" style="text-decoration: line-through;">{{totals.serviceTimeInitialTotal | bringozTimeHHMM}}</span>

        <ng-template #extendedServiceTimeTooltipTmpl>
          <app-visit-plan-extended-service-times-tooltip [visitPlanId]="visitPlan.id"
                                                         [accountId]="account.accountId">
          </app-visit-plan-extended-service-times-tooltip>
        </ng-template>
      </div>
      <!--      <span class="br-body-1 font-weight-400 gray-100 flex-10">-->
      <!--          {{ totals.merchandiseUnitsCount }}-->
      <!--      </span>-->
    </div>

    <!--Cell-->
    <app-visit-plan-accounts-table-row-cell *ngFor="let cell of visitSlots; let index = index"
                                            class="full-height"
                                            [cell]="cell"
                                            [visitPlan]="visitPlan"
                                            [cellTracker]="visitPlanCellTrackerMap[cell.id]"
                                            [visitScheduleDays]="visitScheduleDays"
                                            [visitScheduleDay]="visitScheduleDays[index]"
                                            [dayColWidth]="dayColWidth"
                                            [visitPlanAccountCellAnalysis]="visitPlanAccountCellAnalysisMap[cell.id]"
                                            [tableFilterColumns]="tableFilterColumns"
                                            (onUpdateVisitCellTracker)="onUpdateVisitCellTracker.emit($event)"
                                            (onDeleteCalls)="onDeleteCalls.emit({deletedCallIds: $event.deletedCallIds, cellId: $event.cellId})"
                                            (onUpdateCallsTimeWindow)="onUpdateCallsTimeWindow.emit({list: $event.list, cellId: $event.cellId})"
                                           (onAddCall)="onAddCall.emit({cellId : $event.cellId, date: $event.date})"
                                           (onAdvanceEditCall)="onAdvanceEditCall.emit({cellId: $event.cellId, call: $event.call, visitPlanCell: $event.visitPlanCell})"
                                           (onAssignCallsToResource)="onAssignCallsToResource.emit($event)"
                                            (onUnAssignCalls)="onUnAssignCalls.emit($event)"
                                           (onLockCallChange)="onLockCallChange.emit($event)"
                                           [programTypeAliasMap]="programTypeAliasMap">

    </app-visit-plan-accounts-table-row-cell>

  </div>

</div>
